import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Logo } from "../general/Logo";
import {
  HOME_ROUTE,
  ABOUT_ROUTE,
  FEATURES_ROUTE,
  PRICING_ROUTE,
  SCHOOL_RESOURCES_ROUTE,
  LOGIN_ROUTE,
} from "../../routes/RoutesPathes";
import { CONTACT_EMAIL_1, CONTACT_EMAIL_2 } from "../../constants/constants";
import styles from "./Footer.module.css";

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <Container>
        <Row className="gy-4 justify-content-between align-items-start">
          <Col lg={4} className="d-flex flex-column gap-3">
            <Logo width="150" />
            <p className={styles.tagline}>
              {t("titles.footer_tagline", {
                defaultValue:
                  "Learning management for nurseries, after-school programs, sports academies and Quraan schools. Built by educators, for educators.",
              })}
            </p>
          </Col>

          <Col lg="auto">
            <nav className={styles.links}>
              <Link to={HOME_ROUTE}>{t("pages.home")}</Link>
              <Link to={ABOUT_ROUTE}>{t("pages.about")}</Link>
              <Link to={FEATURES_ROUTE}>{t("pages.features")}</Link>
              <Link to={PRICING_ROUTE}>{t("pages.pricing")}</Link>
              <Link to={SCHOOL_RESOURCES_ROUTE}>{t("pages.resources")}</Link>
              <Link to={LOGIN_ROUTE}>{t("pages.login")}</Link>
            </nav>
          </Col>

          <Col lg={3} className={styles.contact}>
            <span>{t("translation:titles.contact_us")}</span>
            <a href={`mailto:${CONTACT_EMAIL_2}`}>{CONTACT_EMAIL_2}</a>
            <a href={`mailto:${CONTACT_EMAIL_1}`}>{CONTACT_EMAIL_1}</a>
          </Col>
        </Row>

        <div className={styles.bottom}>
          <span>© {new Date().getFullYear()}</span> {t("titles.copyright")}
        </div>
      </Container>
    </footer>
  );
};
